// extracted by mini-css-extract-plugin
module.exports = {"jumbotron":"jumbotron_jumbotron__j8uY2","wrapper":"jumbotron_wrapper__nuS46"};